import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
  selector: 'app-landing-ios-video-overlay',
  standalone: true,
  imports: [CommonModule, TranslateModule, NzIconModule],
  template: `
    <div class="ios-video-overlay" (click)="requestClose()">
      <div
        class="ios-video-dialog"
        role="dialog"
        aria-modal="true"
        [attr.aria-label]="'LANDING.ANNOUNCEMENTS.IOS_INSTALL_VIDEO' | translate"
        (click)="$event.stopPropagation()"
      >
        <button
          type="button"
          class="ios-video-close"
          (click)="requestClose()"
          [attr.aria-label]="'COMMON.CLOSE' | translate"
        >
          <i nz-icon nzType="close"></i>
        </button>

        <div class="ios-video-frame">
          <iframe
            *ngIf="videoUrl"
            [src]="videoUrl"
            [attr.title]="'LANDING.ANNOUNCEMENTS.IOS_INSTALL_VIDEO' | translate"
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
            loading="lazy"
            referrerpolicy="strict-origin-when-cross-origin"
          ></iframe>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .ios-video-overlay {
      position: fixed;
      inset: 0;
      z-index: 4000;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 16px;
      background: rgba(0, 0, 0, 0.72);
    }

    .ios-video-dialog {
      position: relative;
      height: min(85vh, 720px);
      width: min(92vw, calc(min(85vh, 720px) * 750 / 1334));
      aspect-ratio: 750 / 1334;
      border-radius: 16px;
      background: #000;
      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);
      overflow: hidden;
    }

    .ios-video-close {
      position: absolute;
      top: 10px;
      right: 10px;
      z-index: 2;
      width: 36px;
      height: 36px;
      border: 0;
      border-radius: 999px;
      background: rgba(0, 0, 0, 0.66);
      color: #fff;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    .ios-video-frame {
      position: relative;
      width: 100%;
      height: 100%;
      aspect-ratio: 750 / 1334;
      background: #000;
    }

    .ios-video-frame iframe {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      border: 0;
      display: block;
    }

    @media (max-width: 768px) {
      .ios-video-overlay {
        padding:
          max(12px, env(safe-area-inset-top, 0px))
          12px
          max(12px, env(safe-area-inset-bottom, 0px));
      }

      .ios-video-dialog {
        height: min(82vh, 680px);
        width: min(94vw, calc(min(82vh, 680px) * 750 / 1334));
      }

      .ios-video-close {
        top: 8px;
        right: 8px;
      }
    }
  `]
})
export class LandingIosVideoOverlayComponent {
  @Input() videoUrl?: SafeResourceUrl;
  @Output() closeRequested = new EventEmitter<void>();

  requestClose(): void {
    this.closeRequested.emit();
  }
}
